import styled from '@emotion/styled';
import { animated } from 'react-spring';

const AnimatedView = styled(animated.div)``;

AnimatedView.displayName = 'AnimatedView';
export default AnimatedView;
